import { render, staticRenderFns } from "./procurementOrderTemplate.vue?vue&type=template&id=320f0e24&scoped=true"
import script from "./procurementOrderTemplate.vue?vue&type=script&lang=js"
export * from "./procurementOrderTemplate.vue?vue&type=script&lang=js"
import style0 from "./procurementOrderTemplate.vue?vue&type=style&index=0&id=320f0e24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320f0e24",
  null
  
)

export default component.exports